import script from "./WithdrawalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawalModal.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawalModal.vue?vue&type=style&index=0&id=0c92bdb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c92bdb5"]])

export default __exports__